export default "__VITE_ASSET__J5djLRSa__"